import { billListSchema } from '@super-mega/server/contracts/bill'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'
import type { BillOperation } from './bill-action-dialog.tsx'
import { billSearchSchema, DEFAULT_BILL_SEARCH, type BillSearch } from './bill-search.ts'

export const DEFAULT_ORDER_GROUP_BILL_SEARCH: BillSearch = {
  ...DEFAULT_BILL_SEARCH,
  direction: 'receivable',
  collectionStatus: ['notIssued', 'unpaid']
}
export const orderGroupBillQuery = createListQueryPersistence(
  'super-mega:orders:group-bills:list-query',
  billSearchSchema
)

export function createOrderGroupBillOperation(orderGroupId: number): BillOperation {
  const search = billListSchema.parse({
    orderGroupId,
    direction: 'receivable',
    archived: 'all',
    collectionStatus: ['notIssued']
  })
  return { action: 'issue', target: { mode: 'search', search } }
}
